<template>
  <div id="weighted-list-wrap">
    <div class="weighted-item-list">
      <div class="existing-weighted-item" v-for="(item, index) in items" :key="index">
        <input type="text" class="weighted-item-text" v-model="item.text" @blur="updateItem(index)" />
        <span class="weighted-item-value" v-for="(weight, index) in item.weights" :key="index">
          <p>{{ weight.name }}</p>
          <input type="number" v-model.number="weight.value" @blur="updateItem(index)" />
        </span>
      </div>
      <div class="new-weighted-item">
        <input
          type="text"
          class="new-weighted-item-text"
          v-model="newItemText"
          @keyup.enter="addItem"
          @blur="addItem"
        />
        <span
          class="new-weighted-item-weight"
          v-for="(weight, index) in newItemWeights"
          :key="index"
        >
          <p class="new-weighted-item-weight-name">{{ weight.name }}</p>
          <input type="number" class="new-weighted-item-weight-value" v-model.number="weight.value" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeightedSimpleList",
  props: ["items"],
  data() {
    return {
      newItemText: "",
      newItemWeights: [
        { name: "Weight", value: 0 },
        { name: "Uses", value: 1 }
      ],
      currentId: 0
    };
  },
  created() {
    if (this.items.length > 0) {
      this.currentId = this.items[this.items.length - 1].id + 1;
    }
  },
  methods: {
    updateItem: function(index) {
      if (this.items[index]?.text.length === 0) {
        this.items.splice(index, 1);
      }
      this.emitChange();
    },
    addItem: function() {
      if (this.newItemText) {
        this.items.push({
          id: this.currentId++,
          text: this.newItemText,
          weights: this.newItemWeights
        });
        this.newItemText = "";
        this.newItemWeights = [
          { name: "Weight", value: 0 },
          { name: "Uses", value: 0 }
        ];
      }
      this.emitChange();
    },
    emitChange: function() {
      this.$emit("change");
    }
  }
};
</script>
<style lang="css">
#weighted-list-wrap {
}

.weighted-item-list {
  display: flex;
  flex-direction: column;
}

.weighted-item-list input {
  text-align: center;
  padding: 0.5em;
  margin: 0.2em;
}

.existing-weighted-item {
  display: flex;
  margin: 0.2em 0;
}

.weighted-item-text {
  border: none;
  border-bottom: 1px solid #2c3e50;
}

.weighted-item-text:focus {
  border: 1px solid #2c3e50;
  border-radius: 3px;
}

.weighted-item-value p {
  margin-bottom: 0;
  font-size: 12px;
  text-align: center;
}

.weighted-item-value input,
.new-weighted-item-weight-value {
  width: 0.7em;
  height: 0.7em;
  border: 1px solid #9fabb8;
  border-radius: 100%;
}

.new-weighted-item {
  display: flex;
}

.new-weighted-item-weight {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.new-weighted-item-weight-name {
  height: 0.8em;
  font-size: 12px;
  text-align: center;
}

.new-weighted-item-text {
  border: 1px solid #2c3e50;
  border-radius: 3px;
}

.new-weight-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.new-weight-buttons * {
  width: 1.5em;
  background: white;
  font-size: 20px;
}
</style>